import React, {useState} from 'react';
import styles from './DemoForm.module.css'
import Input from "../../../../../components/Utils/Inputs/Input/Input";
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux";
import {getUser} from "../../../../../store/selectors/authSelector";
import Buttons, {
    EnumButtonType,
    EnumButtonWeight,
    EnumColors
} from "../../../../../components/Utils/Buttons/Buttons/Buttons";
import PhoneInput from 'react-phone-number-input/input'
import {toast} from "react-toastify";
import {updateProfileThunk} from "../../../../../store/actions/AuthActions";

const DemoForm = () => {
    const user = useAppSelector(getUser)
    const dispatch = useAppDispatch()

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const isLastName = Boolean(user && user.lastName)
    const isFirstName = Boolean(user && user.firstName)
    const isSecondName = Boolean(user && user.secondName)
    const isOrganization = Boolean(user && user.organization)
    const isPhone = Boolean(user && user.phone)


    const [lastName, setLastName] = useState<string>(user?.lastName ? user.lastName : '')
    const [firstName, setFirstName] = useState<string>(user?.firstName ? user.firstName : '')
    const [secondName, setSecondName] = useState<string>(user?.secondName ? user.secondName : '')
    const [organization, setOrganization] = useState<string>(user?.organization ? user.organization : '')
    const [phone, setPhone] = useState(user?.phone ? user.phone : '')


    const submitHandler = () => {
        const data = {
            lastName,
            firstName,
            secondName,
            organization,
            phone: String(phone)
        }

        console.log('data', data)

        console.log(user)

        const isAllData = Boolean(lastName && firstName && secondName && organization && phone)

        console.log(isAllData, user?.id)

        if (isAllData && user?.id) {
            dispatch(updateProfileThunk({data, id: user.id}))
            console.log('update', data)
        } else {
            toast.warning('Для того что бы продолжить, требуется заполнить все поля')
        }
    }

    return (
        <div className={styles.wrapper}>

            <div className={styles.fullNameWrapper}>
                {!isLastName ?
                    <Input type="text" onChange={(e) => setLastName(e.target.value)} placeholder={'Фамилия'}/> : null}
                {!isFirstName ?
                    <Input type="text" onChange={(e) => setFirstName(e.target.value)} placeholder={'Имя'}/> : null}
                {!isSecondName ? <Input type="text" onChange={(e) => setSecondName(e.target.value)}
                                        placeholder={'Отчество'}/> : null}
            </div>

            {!isOrganization || !isPhone ? <div className={styles.phoneAndOrganizationWrapper}>
                {!isOrganization ?
                    <Input className={styles.organizationInput} onChange={(e) => setOrganization(e.target.value)}
                           type="text" placeholder={'Организация'}/> : null}
                {!isPhone ? <PhoneInput
                    useNationalFormatForDefaultCountryValue={true}
                    className={styles.phoneInput}
                    country="RU"
                    international
                    withCountryCallingCode
                    // @ts-ignore
                    onChange={setPhone} value={phone}/> : null}
            </div> : null}

            <Buttons loading={isLoading} disabled={isLoading} weight={EnumButtonWeight.slim} type={EnumButtonType.filled} color={EnumColors.white}
                     onClick={submitHandler}>{'Сохранить'}</Buttons>

        </div>
    );
};

export default DemoForm;